//通用配置路由，用于退出跳转对应页面等操作
export const LOGIN_NAME = 'login';
//错误页
export const PAGE_NOT_FOUND_NAME = 'PageNotFound';

//登录后Layout框架页默认跳转的页面路由path
export const defaultRoutePath = 'layout/welcome';

// 路由白名单(不需要token验证的页面，请添加路由对应的name至此数组==》,如免登陆的页面，如登录，注册页，公共门户页等)
export const whiteNameList = [
  LOGIN_NAME,
  'icons',
  'error',
  'error-404',
  'portal',
  'EleganceContent',
  'InfoContent',
];
